
<div class="modal-dialog">
    <div class="modal-content">
  
        <div class="modal-header">
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="close()"></button>
        </div>

        <div class="modal-body">
            <div class="scfContainer">
                <div class="row">
                    <div class="col-3">{{ 'LABELS.AMOUNT_TO_PAY' | translate}}</div>
                    <div class="col-9"> 
                        <input type="text" name="payAmount" class="frmInput" [(ngModel)]="payModel.partialOtherReason"
                        #partialOtherReason="ngModel" required>
                    
                    </div>
                </div>
            
                <div class="row">
                    <div class="col-3">{{ 'LABELS.TDS' | translate}}</div>
                    <div class="col-9"> 
                        <input type="text" name="TDS" class="frmInput" [(ngModel)]="payModel.partialOtherReason"
                        #partialOtherReason="ngModel" required>
                    
                    </div>
                </div>
            
                <div class="row">
                    <div class="col-3">{{ 'LABELS.TEST_NOT_REPORTED' | translate}}</div>
                    <div class="col-9"> 
                        <input type="text" name="TNR" class="frmInput" [(ngModel)]="payModel.partialOtherReason"
                        #partialOtherReason="ngModel" required>
                    
                    </div>
                </div>
            
                <div class="row">
                    <div class="col-3">{{ 'LABELS.SAMPLE_NOT_BELONG_TO' | translate}}</div>
                    <div class="col-9"> 
                        <input type="text" name="TNR" class="frmInput" [(ngModel)]="payModel.partialOtherReason"
                        #partialOtherReason="ngModel" required>
                    
                    </div>
                </div>
            
                <div class="row">
                    <div class="col-3">{{ 'LABELS.BILLED_TWICE' | translate}}</div>
                    <div class="col-9"> 
                        <input type="text" name="TNR" class="frmInput" [(ngModel)]="payModel.partialOtherReason"
                        #partialOtherReason="ngModel" required>
                    
                    </div>
                </div>
            
            
                <div class="row">
                    <div class="col-3">{{ 'LABELS.WRONG_TEST_REGISTERED' | translate}}</div>
                    <div class="col-9"> 
                        <input type="text" name="TNR" class="frmInput" [(ngModel)]="payModel.partialOtherReason"
                        #partialOtherReason="ngModel" required>
                    
                    </div>
                </div>
            
                <div class="row">
                    <div class="col-3">{{ 'LABELS.COURIER_CHARGES' | translate}}</div>
                    <div class="col-9"> 
                        <input type="text" name="TNR" class="frmInput" [(ngModel)]="payModel.partialOtherReason"
                        #partialOtherReason="ngModel" required>
                    
                    </div>
                </div>
            
                <div class="row">
                    <div class="col-3">{{ 'LABELS.TOD' | translate}}</div>
                    <div class="col-9"> 
                        <input type="text" name="TNR" class="frmInput" [(ngModel)]="payModel.partialOtherReason"
                        #partialOtherReason="ngModel" required>
                    
                    </div>
                </div>
            
                <div class="row">
                    <div class="col-3">{{ 'LABELS.DR_SAMPLE' | translate}}</div>
                    <div class="col-9"> 
                        <input type="text" name="TNR" class="frmInput" [(ngModel)]="payModel.partialOtherReason"
                        #partialOtherReason="ngModel" required>
                    
                    </div>
                </div>
            
                <div class="row">
                    <div class="col-3">{{'LABELS.FOC' | translate}}</div>
                    <div class="col-9"> 
                        <input type="text" name="TNR" class="frmInput" [(ngModel)]="payModel.partialOtherReason"
                        #partialOtherReason="ngModel" required>
                    
                    </div>
                </div>
            
                <div class="row">
                    <div class="col-3">{{ 'LABELS.TOTAL_DEDUCTION' | translate}}</div>
                    <div class="col-9"> 
                        <input type="text" name="TNR" class="frmInput" [(ngModel)]="payModel.partialOtherReason"
                        #partialOtherReason="ngModel" required>
                    
                    </div>
                </div>
            
                <div class="row button-list">
                    <div class="col-6">
                        <button class="btn  fis-btn" (click)="close()">
                            {{ 'LABELS.CANCEL' | translate}}
                        </button>
                    </div>
                    <div class="col-6">
                        <button class="btn  fis-btn" (click)="close()">
                            {{ 'LABELS.DONE' | translate}}
                        </button>
                    </div>
                </div>
                
            </div>
        </div>

  </div>
</div>
  


